export default "__VITE_ASSET__DgT7Xb67__"